import LangView from "../Views/LangView";
// import SignView from "../Views/SignView";
import Signinview from "../Views/SigninView";
import FirstWelcomeView from "../Views/FirstWelcomeView";
import OtpView from "../Views/OtpView"
import UploadView from "../Views/UploadView";
import ConfirmUploadView from "../Views/ConfirmUploadView";
import MappingScreen from "../Views/MappingScreenView";
import AutoMapSuccess from "../Views/AutoMapSuccessView"
import Header from "../Views/HeaderView"
import Footer from "../Views/FooterView"
import MapMedicineView from "../Views/MapMedicineView";
import HomePage from "../Views/HomePageView"
import DailyRegimenView from "../Views/DailyRegimenView";
import MyTestView from "../Views/MyTestView";
import AddTestView from "../Views/AddTestView";
import Remainder from '../Views/RemainderView'
// import TestResult from "../Views/TestResultFormView";
import TestNotTaken from "../Views/TestNotTakenView";
import TimeSet from "../Views/TimeSetView";
import PopUpForTest from "../Views/PopUpForTestView"
import TestSuccesView from "../Views/TestSuccesView";
import TestLogView from "../Views/TestLogView";
import MedicalRecordsUploadView from "../Views/MedicalRecordsUploadView";
import imageuploadview from "../Views/imageuploadview";
import MyMedicineView from "../Views/MyMedicineView";
import AddMedicineView from "../Views/AddMedicineView";
import MyMedicineLogView from "../Views/MyMedicineLogView"
import MyMedicineSuccessView from "../Views/MyMedicineSuccessView"
import MyMedicineUploadSuccessView from "../Views/MyMedicineUploadSuccessView"
import MyMedicineUploadFailureView from "../Views/MyMedicineUploadFailureView"
import ProfileView from "../Views/ProfileView";
import ProfileEditView from "../Views/ProfileEditView";
import DiagnosticPopupView from "../Views/DiagnosticPopupView";
import DiagnosticSuccessView from "../Views/DiagnosticSuccessView";
import SetDateView from "../Views/SetDateView";
import MyDoctors from "../Views/MyDoctorsView";
import RequestAppoinment from "../Views/RequestAppoinmentView"
import ReceivedAppointmentView from "../Views/ReceivedAppointmentView";
import AppoinmentFormView from "../Views/AppoinmentFormView";
import AppoinmentFailure from "../Views/AppoinmentFailureView";
import UpdateTestView from "../Views/UpdateTestView";
 
const RoutesData = [
  { path: "/", element: LangView, name: "Language Page" },    
  { path: "/signin", element: Signinview, name: "Sign In Page" },
  { path: "/otp", element: OtpView, name: "Sign In Page" },
  { path: "/welcome", element: FirstWelcomeView, name: "Welcome Page" },
  { path: "/upload", element: UploadView, name: "Upload Page" },
  { path: "/confirm-upload", element: ConfirmUploadView, name: "Upload Page" },
  { path: "/mapping", element: MappingScreen, name: "Mapping Page" },
  { path: "/map-medicine", element: MapMedicineView, name: "Map Medicine Page" },
  { path: "/daily-regimen", element: DailyRegimenView, name: "Daily Regimen Page" },
  { path: "/automapsuccess", element: AutoMapSuccess, name: "Mapping Page" },
  { path: "/header", element: Header, name: "header Page" },
  { path: "/footer", element: Footer, name: "footer Page" },
  { path: "/home", element: HomePage, name: "home Page" },
  { path: "/diagnostic", element: DiagnosticPopupView, name: "home Page" },
  { path: "/diagnostic-success", element: DiagnosticSuccessView, name: "home Page" },
  { path: "/set-date", element: SetDateView, name: "home Page" },



  { path: "/remainder", element: Remainder, name: "remainder Page" },
  // { path: "/testresult", element: TestResult, name: "Mapping Page" },
  { path: "/testnottaken", element: TestNotTaken, name: "Mapping Page" },
  { path: "/timeset", element: TimeSet, name: "Mapping Page" },
  { path: "/popup", element: PopUpForTest, name: "Mapping Page" },
  { path: "/medicalrecords", element: MedicalRecordsUploadView, name: "medical records" },
  { path: "/lab-reports", element: imageuploadview, name: "lab reports" },
  { path: "/mymedicine", element: MyMedicineView, name: "my medicine" },
  { path: "/add-medicine", element: AddMedicineView, name: "add records" },
  { path: "/mymedicine-log", element: MyMedicineLogView, name: "medical records" },
  { path: "/mymedicine-success", element: MyMedicineSuccessView, name: "medical records" },
  { path: "/mymedicineupload-success", element: MyMedicineUploadSuccessView, name: "medical records" },
  { path: "/mymedicineupload-failure", element: MyMedicineUploadFailureView, name: "medical records" },
  { path: "/mymedicineupload-failure", element: MyMedicineUploadFailureView, name: "medical records" },
  { path: "/mydoctors", element: MyDoctors, name: "mydoctors" },
  { path: "/requestappoinment", element: RequestAppoinment, name: "request appoinment" },
  { path: "/received", element: ReceivedAppointmentView, name: "request appoinment" },
  { path: "/confirmation-form", element: AppoinmentFormView, name: "confirmation form" },
  { path: "/failure", element: AppoinmentFailure, name: "appoinment failure" },

 
 
  { path: "/mytest", element: MyTestView, name: "MyTest Page" },
  { path: "/add-test", element: AddTestView, name: "MyTest Page" },
  { path: "/update-test", element: UpdateTestView, name: "MyTest Page" },
  { path: "/test-success", element: TestSuccesView, name: "MyTest Page" },
  { path: "/test-log", element: TestLogView, name: "MyTest Page" },


  { path: "/profile", element: ProfileView, name: "Profile Page" },
  { path: "/profile-edit", element: ProfileEditView, name: "Profile Page" },




 
 
 
];
 
export default RoutesData;
 
 